export enum AccessAction {
    SHOW = "SHOW",
    HIDE = "HIDE"
}

export enum AccessRuleMode {
    ROLE = "ROLE",
    USER = "USER",
    QUERY = "QUERY"
}

export enum AccessRuleStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    EXPORT_SHARE = "EXPORT_SHARE"
}

export interface AccessRule {
    id: string;
    name: string;
    mode: AccessRuleMode;
    allRoles: boolean;
    roleIds: number[];
    userIds: number[];
    query: string;
    columns: string[];
    action: AccessAction;
    status: AccessRuleStatus;
}

export interface TableAccessConfig {
    version: 2;
    tableId: string;
    rules: AccessRule[];
}
